import { useStoreState } from '../../models/hooks';

export const useAnonymousUser = (): boolean => {
  const user = useStoreState((state) => state.app.user);

  return !!user?.anonymousUser;
};
